import { userAuthHeader } from 'src/main_app/utils/user_utils/user-auth-header'
import apiGetRequest from './api-get-request'

const getWithToken = apiPath => (params = {}) => apiGetRequest(apiPath)({
    params,
    headers: userAuthHeader,
})

export default getWithToken